import { createReducer, on } from '@ngrx/store';
import { RdsDataProduct, SupportedOperations } from '@rds/rds-metadata-ts';

import { RdsDataProductActions, RdsDataProductApiActions } from '../actions';

export interface State {
  loadingDataProduct: boolean;
  loadingNumberOfVariables: boolean;
  loadingSupportedOperations: boolean;
  numberOfVariables: number | undefined;
  selected: RdsDataProduct | undefined;
  supportedOperations: SupportedOperations | undefined;
}

export const initialState: State = {
  loadingDataProduct: false,
  loadingNumberOfVariables: false,
  loadingSupportedOperations: false,
  numberOfVariables: undefined,
  selected: undefined,
  supportedOperations: undefined,
};

export const reducer = createReducer(
  initialState,
  on(RdsDataProductActions.loadDataProduct, (state) => ({ ...state, loadingDataProduct: true, selected: undefined })),
  on(RdsDataProductApiActions.loadDataProductFailure, (state) => ({
    ...state,
    loadingDataProduct: false,
  })),
  on(RdsDataProductApiActions.loadDataProductSuccess, (state, { dataProduct }) => ({
    ...state,
    loadingDataProduct: false,
    selected: dataProduct,
  })),

  on(RdsDataProductActions.loadVariableCount, (state) => ({ ...state, loadingNumberOfVariables: true, numberOfVariables: undefined })),
  on(RdsDataProductApiActions.loadVariableCountFailure, (state) => ({
    ...state,
    loadingNumberOfVariables: false,
    numberOfVariables: undefined,
  })),
  on(RdsDataProductApiActions.loadVariableCountSuccess, (state, { numberOfVariables }) => ({
    ...state,
    loadingNumberOfVariables: false,
    numberOfVariables,
  })),

  on(RdsDataProductActions.loadSupportedOperations, (state) => ({
    ...state,
    loadingSupportedOperations: true,
    supportedOperations: undefined,
  })),
  on(RdsDataProductApiActions.loadSupportedOperationsFailure, (state) => ({
    ...state,
    loadingSupportedOperations: false,
    supportedOperations: undefined,
  })),
  on(RdsDataProductApiActions.loadSupportedOperationsSuccess, (state, { operations }) => ({
    ...state,
    loadingSupportedOperations: false,
    supportedOperations: operations,
  }))
);

export const getNumberOfVariables = (state: State) => state.numberOfVariables;
export const getSelected = (state: State) => state.selected;
export const getSupportedOperations = (state: State) => state.supportedOperations;
export const isLoadingDataProduct = (state: State) => state.loadingDataProduct;
export const isLoadingNumberOfVariables = (state: State) => state.loadingNumberOfVariables;
export const isLoadingSupportedOperations = (state: State) => state.loadingSupportedOperations;
